import React, { FunctionComponent } from 'react';
import ToolTipComp from '../ToolTipComp';
import styles from './TextMap.module.scss';

interface Props {
  hashName: string;
  fontSize?: number;
  viewUrl?: string;
}
const HashtagName: FunctionComponent<Props> = ({
  hashName,
  fontSize,
  viewUrl,
}) => {
  return (
    <a href={viewUrl} rel="noreferrer" data-testid="view-url-holder">
      <span>
        <ToolTipComp title={hashName}>
          <span
            className={styles.HashtagName}
            style={{
              fontSize: fontSize
                ? `${fontSize <= 10 ? 10 : fontSize}px`
                : '12px !important',
              fontFamily: 'LatoRegular, sans-serif',
            }}
            data-testid="hashtag-name-holder"
          >
            {hashName}
          </span>
        </ToolTipComp>
      </span>
    </a>
  );
};
export default HashtagName;
